// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__-M2vo","header":"Messages_header__35NBa"};